import { FEATURE_GROUPS, type FeatureGroup } from '../../constants';

interface FeaturesListProps {
  groups?: readonly FeatureGroup[];
}

const CheckIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    className="h-6 w-6 flex-shrink-0"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="10" fill="#7CF1C7" />
    <path
      d="M8 12.5l2.5 2.5L16 9.5"
      stroke="#0F766E"
      strokeWidth="2.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FeaturesList = ({ groups = FEATURE_GROUPS }: FeaturesListProps) => {
  return (
    <div className="flex w-full flex-col gap-8">
      {groups.map((group) => (
        <div key={group.id} className="flex flex-col gap-4">
          <h3 className="text-xs font-bold tracking-wider text-catch-dark-blue-90">
            {group.label}
          </h3>
          <ul className="flex flex-col gap-3">
            {group.items.map((item) => (
              <li key={item} className="flex items-start gap-3">
                <CheckIcon />
                <span className="text-base text-catch-dark-blue-90">{item}</span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default FeaturesList;
